import { useEffect, useState } from "react";
import "./index.css";
function Services() {
  const [started, setStarted] = useState(false);
  const [projectCompleted, setProjectsCompleted] = useState(0);
  const [clients, setClient] = useState(0);
  const [lines, setLines] = useState(0);
  const [cups, setCups] = useState(0);

  const resetStats = () => {
    setStarted(false);
    setProjectsCompleted(0);
    setClient(0);
    setLines(0);
    setCups(0);
  };

  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      if (started) {
        if (projectCompleted < 33) setProjectsCompleted((val) => val + 1);
        if (clients < 16) setClient((val) => val + 0.75);
        if (lines < 550) setLines((val) => val + 20);
        if (cups < 2) setCups((val) => val + 0.25);
      }
    }, 100);

    if (!started) clearInterval(interval);
    return () => clearInterval(interval);
  });
  return (
    <div
      className="section section--services"
      id="services"
      onMouseEnter={() => (started ? "" : setStarted(true))}
      onMouseLeave={() => (started && lines === 550 ? resetStats() : "")}
    >
      <div className="section-heading">
        <h2>WHAT I DO</h2>
      </div>
      <div className="sub-section sub-section--services">
        <div className="sub-section__service">
          <div className="sub-section__icon">
            <i className="fa fa-code"></i>
          </div>
          <div>
            <h3>
              <strong>Web </strong>Developement
            </h3>
            <p>
              My major experties includes in tech stacks like{" "}
              <strong>
                Javascript frameworks like Angular, React.js, Next.js, jQuery
                etc
              </strong>
              .
            </p>
          </div>
        </div>
        <div className="sub-section__service">
          <div className="sub-section__icon">
            <i className="fa fa-pencil-square-o"></i>
          </div>
          <div>
            <h3>
              <strong>UX</strong> &amp; Smooth<strong> Interactions</strong>
            </h3>
            <p>
              Create user stories and wireframes that provide simple yet
              complete interaction. Use of Pixel, Axure, Adobe PS, Figma.
            </p>
          </div>
        </div>
        <div className="sub-section__service">
          <div className="sub-section__icon">
            <i className="fa fa-server"></i>
          </div>
          <div>
            <h3>
              <strong>Back End </strong>Development
            </h3>
            <p>
              Create powerful and relentless web services providing flexible
              data supply chain. Develop complex services and service
              architectures like microservices.
            </p>
          </div>
        </div>
        <div className="sub-section__service">
          <div className="sub-section__icon">
            <i className="fa fa-mobile"></i>
          </div>
          <div>
            <h3>
              Native <strong>mobile</strong> app development
            </h3>
            <p>
              Mobile Native development using javascript frameworks like React
              Native.
              <br />
              Wrapper apps based on webview.
            </p>
          </div>
        </div>
        <div className="sub-section__service">
          <div className="sub-section__icon">
            <i className="fa fa-cloud"></i>
          </div>
          <div>
            <h3>
              Cloud <strong>Migrations</strong>
            </h3>
            <p>
              Develop workflows and migrate legacy projects to cloud for more
              availability and automation. I use mostly GCP and Azure.
            </p>
          </div>
        </div>
        <div className="sub-section__service">
          <div className="sub-section__icon">
            <i className="fa fa-bar-chart"></i>
          </div>
          <div>
            <h3>
              Data <strong>Analysis</strong>
            </h3>
            <p>
              I help businesses build marketing strategies, analyze falls and
              predict right decisions by analyzing customer data warehouses.
            </p>
          </div>
        </div>
      </div>
      <div className="sub-section sub-section--services-upsell-item">
        <div className="sub-section__stats">
          <div className="sub-section__stats-icon">
            <i className="fa fa-flag"></i>
          </div>
          <div className="sub-section__stats-value">
            <strong>{projectCompleted}</strong>
          </div>
          <h3>
            <b>PROJECTS</b> COMPLETED
          </h3>
        </div>
        <div className="sub-section__stats">
          <div className="sub-section__stats-icon">
            <i className="fa fa-smile-o"></i>
          </div>
          <div className="sub-section__stats-value">
            <strong>{Math.floor(clients)}</strong>
          </div>
          <h3>
            <b>HAPPY</b> CLIENTS
          </h3>
        </div>
        <div className="sub-section__stats">
          <div className="sub-section__stats-icon">
            <i className="fa fa-code"></i>
          </div>
          <div className="sub-section__stats-value">
            <strong>{lines}k+</strong>
          </div>
          <h3>
            <b>LINES</b> OF CODE
          </h3>
        </div>
        <div className="sub-section__stats">
          <div className="sub-section__stats-icon">
            <i className="fa fa-coffee"></i>
          </div>
          <div className="sub-section__stats-value">
            <strong>{Math.floor(cups)}k+</strong>
          </div>
          <h3>
            <b>CUPS</b> OF TEA & COFFEE
          </h3>
        </div>
      </div>
    </div>
  );
}

export default Services;
